module.exports = __webpack_public_path__ + "img/pdf_icon.37d35a6e.svg";